import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule, TranslatePipe, USE_EXTEND} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppRoutingModule} from './app-routing.module';
import {
	AlertComponent,
	AlertService,
	AuthCoreService,
	CommunicationUtilisateurComponent,
	ConfirmationModalComponent,
	ConfirmationModalService,
	ConnectService,
	LoginComponent,
	NgProgress,
	NgProgressModule,
	NotifierService,
	NouvelleVersionDisponibleComponent,
	NouvelleVersionDisponibleInterceptor,
	OperationsAdminComponent,
	SsoModule,
	StatutAlertComponent,
	StatutService,
	StatutWebsocketComponent,
	TokenInterceptor,
	PremiereLettreMajusculePipe
} from 'sigale-angular';
import {AuthGuardService} from './guards/auth-guard.guard';
import {JwtHelperService, JwtModule} from '@auth0/angular-jwt';
import {MainComponent} from './main.component';
import {AuthService} from './shared/services/auth-service.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe, NgIf, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AccueilComponent} from './accueil/accueil.component';
import {CalendarModule} from 'primeng/calendar';
import {CalendrierComponent} from './shared/components/calendrier/calendrier.component';
import {DeclarerEvenementComponent} from './accueil/declarer-evenement/declarer-evenement.component';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {MessageModule} from 'primeng/message';
import {RecapitulatifDeclarerEvenementModal} from './accueil/declarer-evenement/recapitulatif-declaration-evenement-modal/recapitulatif-declarer-evenement-modal.component';
import {DialogModule} from 'primeng/dialog';
import {ValidationTeletravailComponent} from './validation-teletravail/validation-teletravail.component';
import {TreeTableModule} from 'primeng/treetable';
import {TagModule} from 'primeng/tag';
import {MultiSelectModule} from 'primeng/multiselect';
import {DetailEvenementModalComponent} from './accueil/detail-evenement-modal/detail-evenement-modal.component';
import {ReserverUnBureauComponent} from './reserver-un-bureau/reserver-un-bureau.component';
import {AffichageIlotPourReservationComponent} from './reserver-un-bureau/affichage-ilot-pour-reservation/affichage-ilot-pour-reservation.component';
import {ReserverBureauModalComponent} from './reserver-un-bureau/reserver-bureau-modal/reserver-bureau-modal.component';
import {GridIlotsComponent} from './reserver-un-bureau/grid-ilots/grid-ilots.component';
import {DetailReservationModalComponent} from './accueil/detail-reservation-modal/detail-reservation-modal.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FloatLabelModule} from 'primeng/floatlabel';
import {DividerModule} from 'primeng/divider';
import {JourneeCalendrierComponent} from './shared/components/calendrier/journee-calendrier/journee-calendrier.component';
import {PanelModule} from 'primeng/panel';
import {DropdownModule} from 'primeng/dropdown';
import {GestionEquipeComponent} from './gestion-equipe/gestion-equipe.component';
import {TabViewModule} from 'primeng/tabview';
import {EquipeComponent} from './gestion-equipe/onglets-gestion-equipe/equipe/equipe.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ButtonModule} from 'primeng/button';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TableModule} from 'primeng/table';
import {MenubarModule} from 'primeng/menubar';
import {ToastModule} from 'primeng/toast';
import {MenuModule} from 'primeng/menu';
import {InputTextModule} from 'primeng/inputtext';
import {MenuComponent} from './shared/components/menu/menu.component';
import {CheckboxModule} from 'primeng/checkbox';
import {GroupeDeTravailComponent} from 'src/app/gestion-equipe/onglets-gestion-equipe/groupe-de-travail/groupe-de-travail.component';
import {AjoutUtilisateurComponent} from 'src/app/shared/components/ajout-utilisateur/ajout-utilisateur.component';
import {SelectionZoneComponent} from './shared/components/selection-zone/selection-zone.component';
import {PreferencesComponent} from './shared/components/menu/preferences/preferences.component';
import {GestionZonesAutoriseesComponent} from './shared/components/gestion-zones-autorisees/gestion-zones-autorisees.component';
import {ChipModule} from 'primeng/chip';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {JaugeOccupationComponent} from './shared/components/calendrier/jauge-occupation/jauge-occupation.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {AffichageBureauComponent} from './reserver-un-bureau/grid-ilots/affichage-bureau/affichage-bureau.component';
import {SkeletonModule} from 'primeng/skeleton';
import {InformationConflitModalComponent} from './shared/components/calendrier/information-conflit-modal/information-conflit-modal.component';
import {PlanningComponent} from './planning/planning.component';
import {CalendrierHeaderComponent} from './shared/components/calendrier/calendrier-header/calendrier-header.component';
import {EvenementPlanningComponent} from './planning/evenement-planning/evenement-planning.component';
import {GestionNavetteComponent} from './gestion-navette/gestion-navette.component';
import {TrajetsComponent} from './gestion-navette/onglets-gestion-navette/trajets/trajets.component';
import {ToolbarModule} from 'primeng/toolbar';
import {ListeTrajetsComponent} from './gestion-navette/onglets-gestion-navette/trajets/liste-trajets/liste-trajets.component';
import {CreationModificationTrajetComponent} from './gestion-navette/onglets-gestion-navette/trajets/creation-modification-trajet/creation-modification-trajet.component';
import {PaginatorModule} from 'primeng/paginator';
import {ChipsModule} from 'primeng/chips';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {CarteTrajetComponent} from './shared/components/carte-trajet/carte-trajet.component';
import {FiltrageTrajetsComponent} from './gestion-navette/onglets-gestion-navette/trajets/liste-trajets/filtrage-trajets/filtrage-trajets.component';
import {SidebarModule} from 'primeng/sidebar';
import {DetailTrajetComponent} from './gestion-navette/onglets-gestion-navette/trajets/detail-trajet/detail-trajet.component';
import {ReservationNavetteComponent} from './reservation-navette/reservation-navette.component';
import {SelecteurPeriodeComponent} from './shared/components/selecteur-periode/selecteur-periode.component';
import {AffichageListeTrajetsComponent} from './shared/components/affichage-liste-trajets/affichage-liste-trajets.component';
import {FormulaireTrajetComponent} from './gestion-navette/onglets-gestion-navette/trajets/formulaire-trajet/formulaire-trajet.component';
import {LabelStatutTrajetComponent} from './shared/components/label-statut-trajet/label-statut-trajet.component';
import {DetailReservationTrajetDialogComponent} from './reservation-navette/detail-reservation-trajet-dialog/detail-reservation-trajet-dialog.component';
import {AffichageDepartArriveeComponent} from './shared/components/affichage-depart-arrivee/affichage-depart-arrivee.component';
import {InformationsUtilesComponent} from './shared/components/informations-utiles/informations-utiles.component';
import {LieuxAutocompleteComponent} from './shared/components/lieux-autocomplete/lieux-autocomplete.component';
import {ListeReservationsComponent} from './gestion-navette/onglets-gestion-navette/trajets/detail-trajet/liste-reservations/liste-reservations.component';
import {AccordionModule} from 'primeng/accordion';
import {LigneReservationTrajetComponent} from './shared/components/ligne-reservation-trajet/ligne-reservation-trajet.component';

registerLocaleData(localeFr);

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}

export function tokenGetter() {
	const token = localStorage.getItem('access_token');
	return token ? token : '';
}

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		SsoModule.forRoot({}),
		HttpClientModule,
		JwtModule.forRoot({
			config: {
				tokenGetter: tokenGetter
			}
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		StatutWebsocketComponent,
		CommunicationUtilisateurComponent,
		NouvelleVersionDisponibleComponent,
		NgProgressModule,
		StatutAlertComponent,
		OperationsAdminComponent,
		TabViewModule,
		AutoCompleteModule,
		ButtonModule,
		FormsModule,
		TableModule,
		AlertComponent,
		MenubarModule,
		ToastModule,
		MenuModule,
		InputTextModule,
		CalendarModule,
		ReactiveFormsModule,
		InputTextareaModule,
		RadioButtonModule,
		InputSwitchModule,
		MessageModule,
		TreeTableModule,
		TagModule,
		MultiSelectModule,
		FontAwesomeModule,
		FloatLabelModule,
		ReactiveFormsModule,
		NgIf,
		DividerModule,
		PanelModule,
		DropdownModule,
		CheckboxModule,
		ConfirmationModalComponent,
		AjoutUtilisateurComponent,
		SelectionZoneComponent,
		ChipModule,
		ScrollPanelModule,
		ProgressSpinnerModule,
		LoginComponent,
		SkeletonModule,
		ToolbarModule,
		PaginatorModule,
		DialogModule,
		ChipsModule,
		ConfirmDialogModule,
		SidebarModule,
		PremiereLettreMajusculePipe,
		AccordionModule
	],
	declarations: [
		AppComponent,
		MainComponent,
		GestionEquipeComponent,
		EquipeComponent,
		MenuComponent,
		CalendrierComponent,
		DeclarerEvenementComponent,
		RecapitulatifDeclarerEvenementModal,
		ValidationTeletravailComponent,
		DetailEvenementModalComponent,
		ReserverUnBureauComponent,
		AffichageIlotPourReservationComponent,
		ReserverBureauModalComponent,
		GridIlotsComponent,
		DetailReservationModalComponent,
		JourneeCalendrierComponent,
		AccueilComponent,
		GroupeDeTravailComponent,
		PreferencesComponent,
		GestionZonesAutoriseesComponent,
		JaugeOccupationComponent,
		AffichageBureauComponent,
		InformationConflitModalComponent,
		PlanningComponent,
		CalendrierHeaderComponent,
		EvenementPlanningComponent,
		GestionNavetteComponent,
		TrajetsComponent,
		ListeTrajetsComponent,
		CreationModificationTrajetComponent,
		CarteTrajetComponent,
		FiltrageTrajetsComponent,
		DetailTrajetComponent,
		ReservationNavetteComponent,
		SelecteurPeriodeComponent,
		AffichageListeTrajetsComponent,
		FormulaireTrajetComponent,
		LabelStatutTrajetComponent,
		DetailReservationTrajetDialogComponent,
		AffichageDepartArriveeComponent,
		InformationsUtilesComponent,
		LieuxAutocompleteComponent,
		ListeReservationsComponent,
		LigneReservationTrajetComponent
	],
	providers: [
		AuthService,
		AuthCoreService,
		NotifierService,
		ConnectService,
		AuthGuardService,
		NgProgress,
		NotifierService,
		NgbActiveModal,
		JwtHelperService,
		NotifierService,
		StatutService,
		AlertService,
		{
			provide: LOCALE_ID,
			useValue: 'fr'
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: NouvelleVersionDisponibleInterceptor,
			multi: true
		},
		{
			provide: USE_EXTEND,
			useValue: true
		},
		TranslatePipe,
		DatePipe,
		MessageService,
		ConfirmationService,
		ConfirmationModalService
	],
	bootstrap: [AppComponent]

})
export class AppModule {
}
